import { render, staticRenderFns } from "./DialogUncaughtError.vue?vue&type=template&id=1bffa6d2&scoped=true&"
import script from "./DialogUncaughtError.vue?vue&type=script&lang=js&"
export * from "./DialogUncaughtError.vue?vue&type=script&lang=js&"
import style0 from "./DialogUncaughtError.vue?vue&type=style&index=0&id=1bffa6d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bffa6d2",
  null
  
)

export default component.exports